import { render } from "./BreadcrumbToolbar2.vue?vue&type=template&id=bc1d5026&scoped=true"
import script from "./BreadcrumbToolbar2.vue?vue&type=script&lang=js"
export * from "./BreadcrumbToolbar2.vue?vue&type=script&lang=js"

import "./BreadcrumbToolbar2.vue?vue&type=style&index=0&id=bc1d5026&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc1d5026"]])

export default __exports__